module.exports = {"430382100":"清溪镇","430382101":"银田镇","430382200":"韶山乡","430382203":"杨林乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/430382.json
// module id = 1956
// module chunks = 0